<script>
/* eslint-disable vue/no-unused-components */
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */

import DatafileResultService from "@/api/services/datafileResult.service.js";
import DataFetchingErrorWidget from "@/shared/components/widgets/data-fetching-error.vue";
import { EventBus } from "@/shared/util/event-bus.js";
import OESInfoModal from "./OES-info-modal.vue";

export default {
  props: {
    datafileId: String
  },
  components: {
    OESInfoModal,
    DataFetchingErrorWidget
  },
  data() {
    return {
      /**** Data Varaibles ****/
      metadata: null,
      /**** Operationsal Varaibles ****/
      isDisplayData: false,
      isFetchingDataError: false,
      isDisplayInfoModal: false
    };
  },
  async created() {
    await this.fetchMetaData();
    this.$emit("dataFetchingDone");
    this.initializeEventBus();
  },
  methods: {
    async fetchMetaData() {
      await DatafileResultService.getOESMetadata(this.datafileId, true)
        .then(data => {
          this.metadata = data;
          this.isDisplayData = true;
        })
        .catch(e => {
          this.isFetchingDataError = true;
          this.isDisplayData = true;
        });
    },
    initializeEventBus() {
      // EventBus
      EventBus.$on("updateQualityWidgets", async () => {
        await this.fetchMetaData();
      });
    },
    clickQualityScoreInfoModal() {
      this.isDisplayInfoModal = true;
    }
  }
};
</script>

<template>
  <div class="card">
    <div class="card-body" v-if="isDisplayData">
      <div class="card-title">
        {{ $t("qualityScoreWidgets.openEndedScoreWidget.title") }}
        <i
          class="bx bxs-info-circle font-size-18 text-info bx-tada ml-2"
          style="cursor: pointer"
          @click="clickQualityScoreInfoModal()"
        ></i>
      </div>

      <b-row v-if="!this.isFetchingDataError">
        <!-- Number of Questions -->
        <b-col sm="4" class="mb-3">
          <div>
            {{ $t("datafileResultOESTab.metadataWidget.numberOfDataPoints") }}
          </div>
          <div>
            <strong>{{ metadata.numberOfDatapoints }}</strong>
          </div>
        </b-col>

        <!-- All Data Records -->
        <b-col sm="4" class="mb-3">
          <div>
            {{ $t("datafileResultOESTab.metadataWidget.numberOfDataRecords") }}
          </div>
          <div>
            <strong>{{ metadata.numberOfRecords }}</strong>
          </div>
        </b-col>

        <!-- Data Records without Scores -->
        <b-col sm="4" class="mb-3">
          <div>
            {{
              $t("datafileResultOESTab.metadataWidget.numberOfInvalidDataRecords")
            }}
          </div>
          <div>
            <strong>{{ metadata.numberOfInvalidRecords }}</strong>
          </div>
        </b-col>

        <!-- Wrong Topic Check Enabled -->
        <b-col sm="4" class="mb-3">
          <div>
            {{
              $t("datafileResultOESTab.metadataWidget.contextCheck")
            }}
          </div>
          <span v-if="metadata.isEnableWrongTopicCheck">
            <b-badge style="font-size: 12px" variant="info">
              {{
                $t("datafileResultOESTab.metadataWidget.yes")
              }}
            </b-badge>
          </span>
          <span v-if="!metadata.isEnableWrongTopicCheck">
            <b-badge style="font-size: 12px" variant="info">
              {{
                $t("datafileResultOESTab.metadataWidget.no")
              }}
            </b-badge>
          </span>
        </b-col>

        <!-- Duplicate Check Enabled -->
        <b-col sm="4" class="mb-3">
          <div>
            {{
              $t("datafileResultOESTab.metadataWidget.duplicateCheck")
            }}
          </div>
          <span v-if="metadata.enableDuplicateChecks">
            <b-badge style="font-size: 12px" variant="info">
              {{
                $t("datafileResultOESTab.metadataWidget.yes")
              }}
            </b-badge>
          </span>
          <span v-if="!metadata.enableDuplicateChecks">
            <b-badge style="font-size: 12px" variant="info">
              {{
                $t("datafileResultOESTab.metadataWidget.no")
              }}
            </b-badge>
          </span>
        </b-col>       
      </b-row>

      <div class="card-text mt-3" v-if="this.isFetchingDataError">
        <DataFetchingErrorWidget />
      </div>
    </div>

    <!-- Loading untile data get set --->
    <div class="card-body" v-else>
      <div class="row justify-content-center">
        <div class="col-6 text-center">
          <b-spinner
            style="width: 5rem; height: 5rem"
            class="m-2"
            variant="mid"
            role="status"
          ></b-spinner>
        </div>
      </div>
    </div>

    <!-- Info Modal -->
    <OESInfoModal
      v-if="isDisplayInfoModal"
      :visible="isDisplayInfoModal"
      @close="isDisplayInfoModal = false"
    />
  </div>
</template>
